import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PropertyListing from './PropertyListing';
import Return from './Return';
import ContactUs from './ContactUs';
import HouseRules from './HouseRules';
import CheckoutForm from './CheckoutForm';
import Terms from './Terms';
import ScrollToTop from './ScrollToTop';
import CleanerChecklist from './CleanerChecklist';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<PropertyListing />} />
          <Route path="/success" element={<Return />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/house-rules" element={<HouseRules />} />
          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cleaner-checklist" element={<CleanerChecklist />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
